export default __webpack_public_path__ + "static/media/cart_cart.0995d98f.jpg";